import { ProgressAction } from '../constants';

const initialState = {
  loading: 0
};

export function progressReducer(state = initialState, action) {
  switch (action.type) {
    case ProgressAction.SHOW_PROGRESS:
      return {
        ...state,
        loading: state.loading + 1,
      };
      
    case ProgressAction.HIDE_PROGRESS:
      return {
        ...state,
        loading: state.loading - 1,
      };

    case ProgressAction.RESET_PROGRESS:
      return {
        ...state,
        loading: 0,
      };

    default:
      return state;
  }
}